// 게임사 영문명과 한글명 매핑
const providerNameMap = {
  // 슬롯 게임사
  'Pragmatic Play': '프라그마틱 플레이',
  'pragmatic play': '프라그마틱 플레이',
  'pragmaticplay': '프라그마틱 플레이',
  'Pragmatic': '프라그마틱',
  'pragmatic': '프라그마틱',
  'NetEnt': '넷엔트',
  'netent': '넷엔트',
  'Microgaming': '마이크로게이밍',
  'microgaming': '마이크로게이밍',
  'Play\'n GO': '플레이앤고',
  'playngo': '플레이앤고',
  'play n go': '플레이앤고',
  'Yggdrasil': '이그드라실',
  'yggdrasil': '이그드라실',
  'Red Tiger': '레드 타이거',
  'red tiger': '레드 타이거',
  'redtiger': '레드 타이거',
  'Big Time Gaming': '빅타임 게이밍',
  'big time gaming': '빅타임 게이밍',
  'bigtimegaming': '빅타임 게이밍',
  'Quickspin': '퀵스핀',
  'quickspin': '퀵스핀',
  'Thunderkick': '썬더킥',
  'thunderkick': '썬더킥',
  'Blueprint Gaming': '블루프린트 게이밍',
  'blueprint gaming': '블루프린트 게이밍',
  'blueprintgaming': '블루프린트 게이밍',
  'Habanero': '하바네로',
  'habanero': '하바네로',
  'Booongo': '부옹고',
  'booongo': '부옹고',
  'Endorphina': '엔돌피나',
  'endorphina': '엔돌피나',
  'Evoplay': '에보플레이',
  'evoplay': '에보플레이',
  'Relax Gaming': '릴랙스 게이밍',
  'relax gaming': '릴랙스 게이밍',
  'relaxgaming': '릴랙스 게이밍',
  'Push Gaming': '푸시 게이밍',
  'push gaming': '푸시 게이밍',
  'pushgaming': '푸시 게이밍',
  'Nolimit City': '노리밋 시티',
  'nolimit city': '노리밋 시티',
  'nolimitcity': '노리밋 시티',
  'Nolimit': '노리밋',
  'nolimit': '노리밋시티',
  'Hacksaw Gaming': '핵소우 게이밍',
  'hacksaw gaming': '핵소우 게이밍',
  'hacksawgaming': '핵소우 게이밍',
  'PG Soft': 'PG 소프트',
  'pg soft': 'PG 소프트',
  'pgsoft': 'PG 소프트',
  'Spadegaming': '스페이드게이밍',
  'spadegaming': '스페이드게이밍',
  'spade gaming': '스페이드게이밍',
  
  // 라이브 카지노 게임사
  'Evolution': '에볼루션',
  'evolution': '에볼루션',
  'evolution gaming': '에볼루션',
  'Ezugi': '이주기',
  'ezugi': '이주기',
  'Playtech': '플레이텍',
  'playtech': '플레이텍',
  'Asia Gaming': '아시아 게이밍',
  'asia gaming': '아시아 게이밍',
  'asiagaming': '아시아 게이밍',
  'Sexy Gaming': '섹시 게이밍',
  'sexy gaming': '섹시 게이밍',
  'sexygaming': '섹시 게이밍',
  'Sexy': '섹시',
  'sexy': '섹시',
  'SEXY': '섹시',
  'Dream Gaming': '드림 게이밍',
  'dream gaming': '드림 게이밍',
  'dreamgaming': '드림 게이밍',
  'DREAMGAME': '드림게임스',
  'dreamgame': '드림게임',
  'Oriental Gaming': '오리엔탈 게이밍',
  'oriental gaming': '오리엔탈 게이밍',
  'orientalgaming': '오리엔탈 게이밍',
  'Allbet': '올벳',
  'allbet': '올벳',
  'Allbet': '올벳',
  'allbet': '올벳',
  'Allbet': '올벳',
  'allbet': '올벳',
  'Allbet': '올벳',
  'asiagaming': '아시아게이밍',
  'asia gaming': '아시아게이밍',
  'asia': '아시아',
  'Asia': '아시아',
  'asia': '아시아',
  'AG': '아시아게이밍',
  'ag': '아시아게이밍',
  'AG': '아시아게이밍',
  'microgaming': '마이크로게이밍',
  'Microgaming': '마이크로게이밍',
  'Micro': '마이크로',
  'micro': '마이크로',
  'Microgaming': '마이크로게이밍',
  'microgaming': '마이크로게이밍',
  'Microgaming': '마이크로게이밍',
  'micro': '마이크로',
  'MG': '마이크로게이밍',
  'mg': '마이크로게이밍',
  'MG': '마이크로게이밍',
  'SA Gaming': 'SA 게이밍',
  'sa gaming': 'SA 게이밍',
  'sagaming': 'SA 게이밍',
  'WM Casino': 'WM 카지노',
  'wm casino': 'WM 카지노',
  'wmcasino': 'WM 카지노',
  'WM': 'WM 카지노',
  'wm': 'WM 카지노',
  'VIVO': '비보',
  'vivo': '비보',
  'vivogaming': '비보',

  
  // 기타 게임사
  'CQ9': 'CQ9',
  'cq9': 'CQ9',
  'JDB': 'JDB',
  'jdb': 'JDB',
  'FC': 'FC',
  'fc': 'FC',
  'Jili': '질리',
  'jili': '질리',
  'KA Gaming': 'KA 게이밍',
  'ka gaming': 'KA 게이밍',
  'kagaming': 'KA 게이밍',
  'Playstar': '플레이스타',
  'playstar': '플레이스타',
  'Playstar Gaming': '플레이스타 게이밍',
  'playstar gaming': '플레이스타 게이밍',
  'playstargaming': '플레이스타 게이밍',
  'Playstar': '플레이스타',

  // 추가 게임사들
  'Betsoft': '벳소프트',
  'betsoft': '벳소프트',
  'RTG': 'RTG',
  'rtg': 'RTG',
  'Rival': '라이벌',
  'rival': '라이벌',
  'Spinomenal': '스피노메날',
  'spinomenal': '스피노메날',
  'Wazdan': '와즈단',
  'wazdan': '와즈단',
  'Iron Dog Studio': '아이언독 스튜디오',
  'iron dog studio': '아이언독 스튜디오',
  'irondogstudio': '아이언독 스튜디오',
  'Elk Studios': '엘크 스튜디오',
  'elk studios': '엘크 스튜디오',
  'elkstudios': '엘크 스튜디오'
};

// 실제 파일명 매핑 테이블 (게임사 이름 -> 실제 파일명)
const providerFileNameMap = {
  // 정확한 매칭
  'pragmatic play': 'pragmatic',
  'pragmaticplay': 'pragmatic',
  'pragmatic': 'pragmatic',
  'netent': 'netent',
  'microgaming': 'microgaming',
  'play\'n go': 'playngo',
  'playngo': 'playngo',
  'yggdrasil': 'yggdrasil',
  'red tiger': 'redtiger',
  'redtiger': 'redtiger',
  'big time gaming': 'btg',
  'bigtimegaming': 'btg',
  'btg': 'btg',
  'BTG': 'btg',
  'quickspin': 'quickspin',
  'thunderkick': 'thunderkick',
  'blueprint gaming': 'blueprint',
  'blueprint': 'blueprint',
  'habanero': 'habanero',
  'booongo': 'booogo',
  'evoplay': 'evoplay',
  'relax gaming': 'relaxgaming',
  'relax': 'relaxgaming',
  'relaxgaming': 'relaxgaming',
  'hacksaw gaming': 'hacksaw',
  'hacksaw': 'hacksaw',
  'pg soft': 'pgsoft',
  'pgsoft': 'pgsoft',
  'spadegaming': 'spadegaming',
  'evolution': 'evolution',
  'evolution gaming': 'evolution',
  'playtech': 'playtech',
  'asia gaming': 'asiagaming',
  'asiagaming': 'asiagaming',
  'dream gaming': 'dreamgaming',
  'dreamgaming': 'dreamgaming',
  'allbet': 'allbet',
  'wm casino': 'wmcasino',
  'wmcasino': 'wmcasino',
  'cq9': 'cq9',
  'betsoft': 'betsoft',
  'spinomenal': 'spinomenal',
  'wazdan': 'wazdan',
  'elk studios': 'elk',
  'elk': 'elk',
  
  // 추가 매핑들
  '1x2gaming': '1x2gaming',
  'aesexy': 'aesexy',
  'aspectgaming': 'aspectgaming',
  'avatarux': 'avatarux',
  'bbin': 'bbin',
  'bbtech': 'bbtech',
  'bet365': 'bet365',
  'betconstruct': 'betconstruct',
  'betgames': 'betgames',
  'biggaming': 'biggaming',
  'bti': 'bti',
  'dragongaming': 'dragongaming',
  'dreamtech': 'dreamtech',
  'gameart': '게임아트',
  'gameplay': '게임플레이',
  'ibobet': '이보벳',
  'manaplay': '마나플레이',
  'mancalagaming': 'mancalagaming',
  'mega7': '메가7',
  'mobilots': '모바일롯스',
  'nextspin': '넥스트스핀',
  'orientalgameplus': 'orientalgameplus',
  'pinnacle': 'pinnacle',
  'playpearls': 'playpearls',
  'playson': 'playson',
  'playstar': 'playstar',
  'redrake': 'redrake',
  'reelkingdom': 'reelkingdom',
  'rtgslots': 'rtgslots',
  'sbobet': 'sbobet',
  'skywind': 'skywind',
  'taishan': 'taishan',
  'tomhorn': 'tomhorn',
  'toptrend': 'toptrend',
  'tpg': 'tpg',
  'VIVO': '비보',
  'vivo': '비보',
  'vivogaming': '비보',
  'vivogaming': '비보',
  'vivogaming': 'vivogaming',
  
  // Missing providers that were causing logo mismatches
  'macaw': 'macaw',
  'macaw gaming': 'macaw',
  'macawgaming': 'macaw',
  'Macaw': 'macaw',
  'Macaw Gaming': 'macaw',
  'merkur': 'merkur',
  'merkur gaming': 'merkur',
  'merkurgaming': 'merkur',
  'Merkur': 'merkur',
  'Merkur Gaming': 'merkur',
  'novomatic': 'novomatic',
  'Novomatic': 'novomatic',
  
  // Additional providers found in logo directory
  '7mojos': '7mojos',
  '7 mojos': '7mojos',
  'amigogaming': 'amigogaming',
  'amigo gaming': 'amigogaming',
  'bgaming': 'bgaming',
  'b gaming': 'bgaming',
  'bfgames': 'bfgames',
  'bf games': 'bfgames',
  'bigtimegaming': 'bigtimegaming',
  'boomerang': 'boomerang',
  'boominggames': 'boominggames',
  'booming games': 'boominggames',
  'booogo': 'booogo',
  'caletagaming': 'caletagaming',
  'caleta gaming': 'caletagaming',
  'dragoonsoft': 'dragoonsoft',
  'dragoon soft': 'dragoonsoft',
  'eagaming': 'eagaming',
  'ea gaming': 'eagaming',
  'fantasma': 'fantasma',
  'fantasma games': 'fantasma',
  'fatpanda': 'fatpanda',
  'fat panda': 'fatpanda',
  'fils': 'fils',
  'funkygames': 'funkygames',
  'funky games': 'funkygames',
  'funtagaming': 'funtagaming',
  'funta gaming': 'funtagaming',
  'gameart': 'gameart',
  'game art': 'gameart',
  'gmw': 'gmw',
  'greentube': 'greentube',
  'green tube': 'greentube',
  'iconix': 'iconix',
  'intouchgames': 'intouchgames',
  'intouch games': 'intouchgames',
  'joker': 'joker',
  'joker gaming': 'joker',
  'kalamba': 'kalamba',
  'kalamba games': 'kalamba',
  'mancala': 'mancala',
  'mancala gaming': 'mancala',
  'mplay': 'mplay',
  'm play': 'mplay',
  'nagagames': 'nagagames',
  'naga games': 'nagagames',
  'netgame': 'netgame',
  'net game': 'netgame',
  'netgaming': 'netgaming',
  'net gaming': 'netgaming',
  'octoplay': 'octoplay',
  'octo play': 'octoplay',
  'petersons': 'petersons',
  'platingaming': 'platingaming',
  'platin gaming': 'platingaming',
  'platipus': 'platipus',
  'popok': 'popok',
  'popok gaming': 'popok',
  'reelplay': 'reelplay',
  'reel play': 'reelplay',
  'retrogames': 'retrogames',
  'retro games': 'retrogames',
  'revolver': 'revolver',
  'revolver gaming': 'revolver',
  'rsg': 'rsg',
  'rubyplay': 'rubyplay',
  'ruby play': 'rubyplay',
  'slotmatrix': 'slotmatrix',
  'slot matrix': 'slotmatrix',
  'slotmill': 'slotmill',
  'slot mill': 'slotmill',
  'theplayer': 'theplayer',
  'the player': 'theplayer',
  'xpans': 'xpans',
  'ygr': 'ygr',
  'yolted': 'yolted'
};

/**
 * 게임사 영문명을 받아서 한글명을 반환
 * @param {string} englishName - 게임사 영문명
 * @returns {string} 게임사 한글명
 */
export const getProviderKoreanName = (englishName) => {
  if (!englishName) return englishName;
  
  // 정확한 매칭 시도
  if (providerNameMap[englishName]) {
    return providerNameMap[englishName];
  }
  
  // 소문자로 변환해서 매칭 시도
  const lowerName = englishName.toLowerCase();
  if (providerNameMap[lowerName]) {
    return providerNameMap[lowerName];
  }
  
  // 공백과 특수문자 제거 후 매칭 시도
  const cleanName = englishName.toLowerCase().replace(/['\s\-_]/g, '');
  if (providerNameMap[cleanName]) {
    return providerNameMap[cleanName];
  }
  
  // 매칭되지 않으면 원래 이름 반환
  return englishName;
};

/**
 * 게임사 정보를 포맷팅하여 반환
 * @param {string} providerName - 게임사 이름
 * @returns {object} { english: string, korean: string }
 */
export const getProviderNames = (providerName) => {
  if (!providerName) {
    return {
      english: 'Unknown',
      korean: '알 수 없음'
    };
  }
  
  return {
    english: providerName,
    korean: getProviderKoreanName(providerName)
  };
};

/**
 * 게임사 이름을 실제 파일명으로 변환
 * @param {string} providerName - 게임사 이름
 * @returns {string} 실제 파일명
 */
export const getProviderFileName = (providerName) => {
  if (!providerName) return 'unknown';
  
  const lowerName = providerName.toLowerCase();
  
  // 정확한 매칭 먼저 시도
  if (providerFileNameMap[lowerName]) {
    return providerFileNameMap[lowerName];
  }
  
  // 공백과 특수문자 제거 후 매칭 시도
  const cleanName = lowerName.replace(/['\s\-_&]/g, '');
  if (providerFileNameMap[cleanName]) {
    return providerFileNameMap[cleanName];
  }
  
  // 매칭되지 않으면 기본 변환 로직 사용
  return cleanName;
};

/**
 * 주요 게임사별 로고 파일명 매핑 가이드
 */
export const getProviderLogoGuide = () => {
  const providers = [
    'Pragmatic Play',
    'NetEnt', 
    'Microgaming',
    'Play\'n GO',
    'Yggdrasil',
    'Red Tiger',
    'Big Time Gaming',
    'Quickspin',
    'Thunderkick',
    'Blueprint Gaming',
    'Evolution',
    'Ezugi',
    'Playtech',
    'Asia Gaming',
    'Sexy Gaming',
    'Dream Gaming',
    'Oriental Gaming',
    'Allbet',
    'SA Gaming',
    'WM Casino',
    'CQ9',
    'JDB',
    'FC',
    'Jili',
    'KA Gaming',
    'PG Soft',
    'Spadegaming',
    'Habanero',
    'Booongo',
    'Endorphina',
    'Evoplay',
    'Relax Gaming',
    'Push Gaming',
    'Nolimit City',
    'Hacksaw Gaming'
  ];

  const slotLogos = providers.map(provider => ({
    provider,
    fileName: `vender-logo-${getProviderFileName(provider)}.png`,
    korean: getProviderKoreanName(provider)
  }));

  const casinoLogos = providers.map(provider => ({
    provider,
    fileName: `vender-logo-${getProviderFileName(provider)}.png`,
    korean: getProviderKoreanName(provider)
  }));

  return { slotLogos, casinoLogos };
};

export const providerNames = providerNameMap;
